import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/shared/lib/api'

// ── Dashboard ──────────────────────────────────────
export const useAREDashboard = () =>
  useQuery({
    queryKey: ['are', 'dashboard'],
    queryFn: () => api.get('/are/dashboard').then((r) => r.data.data),
  })

// ── CRM ────────────────────────────────────────────
export const useCRMStatus = () =>
  useQuery({
    queryKey: ['are', 'crm', 'status'],
    queryFn: () => api.get('/are/crm/status').then((r) => r.data.data),
  })

export const useContacts = (params?: { segment?: string; page?: number }) =>
  useQuery({
    queryKey: ['are', 'contacts', params],
    queryFn: () => api.get('/are/crm/contacts', { params }).then((r) => r.data),
  })

// ── Campaigns ──────────────────────────────────────
export const useCampaigns = () =>
  useQuery({
    queryKey: ['are', 'campaigns'],
    queryFn: () => api.get('/are/campaigns').then((r) => r.data.data),
  })

export const useCampaign = (id: string) =>
  useQuery({
    queryKey: ['are', 'campaigns', id],
    queryFn: () => api.get(`/are/campaigns/${id}`).then((r) => r.data.data),
    enabled: !!id,
  })

export const useCreateCampaign = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: any) => api.post('/are/campaigns', data).then((r) => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['are'] }),
  })
}

export const useUpdateCampaign = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }: any) => api.patch(`/are/campaigns/${id}`, data).then((r) => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['are'] }),
  })
}

export const usePauseCampaign = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.post(`/are/campaigns/${id}/pause`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['are'] }),
  })
}

// ── Send Requests ──────────────────────────────────
export const useSendRequests = (params?: { status?: string; page?: number }) =>
  useQuery({
    queryKey: ['are', 'send-requests', params],
    queryFn: () => api.get('/are/send-requests', { params }).then((r) => r.data),
  })

// ── Feedback ───────────────────────────────────────
export const useFeedbackResponses = (params?: { status?: string; page?: number }) =>
  useQuery({
    queryKey: ['are', 'feedback', params],
    queryFn: () => api.get('/are/feedback-form/responses', { params }).then((r) => r.data),
  })

// ── Analytics ──────────────────────────────────────
export const useFunnel = () =>
  useQuery({
    queryKey: ['are', 'analytics', 'funnel'],
    queryFn: () => api.get('/are/analytics/funnel').then((r) => r.data.data),
  })
